import { Typography,Box } from "@mui/material";

export default function ErrorPage(){
    return(
        <Box sx={{height:"100vh",width:"100%",background:"#fff",display:"flex",justifyContent:"center",alignItems:"center",zIndex:999,flexDirection:"column",}}>
            <Typography variant="h5" color={"black"} textAlign={"center"}>Oops Page Not Found</Typography>
            <Typography variant="h1" color={"black"} textAlign={"center"}>404 Not Found</Typography>
        </Box>
    )
}